<template>
  <el-container class="container">
    <div style="display: none" class="genus-input">
      <el-row>
      <span class="ml-3 w-35 text-gray-600 inline-flex items-center">Genus</span>
        <el-input
            v-model="genusName"
            class="w-50 m-2"
            placeholder='Like "Notropis"'
            :suffix-icon="Search"
        />
        <span class="ml-3 w-35 text-gray-600 inline-flex items-center">Family</span>
        <el-input
            v-model="familyName"
            class="w-50 m-2"
            placeholder='Like "Cyprinidae"'
            :suffix-icon="Search"
        />
<!--        <span class="ml-3 w-35 text-gray-600 inline-flex items-center">Min Height(pixel)</span>-->
<!--        <el-input-->
<!--            v-model="minHeight"-->
<!--            class="w-50 m-2"-->
<!--            placeholder="100"-->
<!--            :suffix-icon="Search"-->
<!--        />-->
<!--        <span class="ml-3 w-35 text-gray-600 inline-flex items-center">Max Height(pixel)</span>-->
<!--        <el-input-->
<!--            v-model="maxHeight"-->
<!--            class="w-50 m-2"-->
<!--            placeholder="6000"-->
<!--            :suffix-icon="Search"-->
<!--        />-->
        <span class="ml-3 w-35 text-gray-600 inline-flex items-center">Dataset</span>
        <el-select v-model="dataset" class="m-2" placeholder="Select">
          <el-option
              v-for="item in datasetLists"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
        <el-button type="primary" :disabled="!isDownloadActive" @click="getName" class="inline-flex items-center w-50 m-2">
          Search<el-icon class="el-icon--right"></el-icon>
        </el-button>
        <el-button type="primary" :disabled="!isDownloadActive" @click="downloadZipfile" class="inline-flex items-center w-50 m-2">
          Download<el-icon class="el-icon--right"><Download /></el-icon>
        </el-button>

      </el-row>
    </div>

  </el-container>
  <div class="arkid-input">
    <el-row>
      <span class="ml-3 w-35 text-gray-600 inline-flex items-center">ArkID</span
      >
      <el-input
          v-model="arkID"
          class="w-50 m-2"
          @keyup.enter="getArkID"
          placeholder="exp:qs243w0c"
          :suffix-icon="Search"
      />

    </el-row>
    <el-row>
      <p class="text-gray-600 inline-flex items-center">For this beta version. You can see a maximum of 20 data and download a maximum of 200 data. If you would like to access more data, please  &nbsp;<span> <a href="mailto:xwang48@tulane.edu"> contact </a></span> &nbsp; us.
      </p
      >
    </el-row>
  </div>
  <el-row>
    <el-col
        :span="5"
        v-for="(item) in multimediaList"
        :key="item"
        :offset="2"
        style="margin-bottom: 10px;"
    >
      <el-card :body-style="{ padding: '10px', margin: '10px' }">
        <img
            :src=item.path rel="external nofollow"
            class="image"
        />
        <div style="padding: 14px;">
          <span>{{ item.scientific_name }}</span>
          <div class="bottom">
            <time class="time">{{ item.ark_id }}.{{item.format}}</time>
          </div>
          <div class="bottom">
            <time class="time">Batch: {{ item.batch_id }}</time>
            <el-button type="text" class="button" @click="showDialog(item)">>></el-button>
          </div>
          <el-tag>Quality Metadata</el-tag>
<!--          <el-tag class="ml-2" type="success">Bounding Box</el-tag>-->
<!--          <el-tag class="ml-2" type="info">Segmentation</el-tag>-->
          <el-tag class="ml-2" type="warning">Original Resource</el-tag>
<!--          <el-tag class="ml-2" type="danger">AI-Ready</el-tag>-->
        </div>
      </el-card>
    </el-col>
  </el-row>

  <el-dialog v-model="visible" :show-close="false">
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <h4 :id="titleId" :class="titleClass">ARK ID:{{oneMultimedia.ark_id}}</h4>
        <el-button type="danger" @click="close">
          <el-icon class="el-icon--left"><CircleCloseFilled /></el-icon>
          Close
        </el-button>
      </div>
    </template>
    <div class="dialog-content">
      <img
          :src=oneMultimedia.path rel="external nofollow"
          class="image"
      />
      <el-tabs type="border-card">
        <el-tab-pane label="Multimedia">
          <div class="MultimeidaInfo --el-box-shadow-light">
            <el-row>
              <el-col :span="12" class="left-col">ArkID</el-col><el-col :span="12" class="right-col">{{oneMultimedia.ark_id}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="left-col">ParentArkId</el-col><el-col :span="12" class="right-col">{{oneMultimedia.parent_ark_id}}</el-col>
              <el-col :span="12" class="left-col">accessURI</el-col><el-col :span="12" class="right-col">{{oneMultimedia.path}}</el-col>
              <el-col :span="12" class="left-col">FileNameAsDelivered</el-col><el-col :span="12" class="right-col">{{oneMultimedia.filename_as_delivered}}</el-col>
              <el-col :span="12" class="left-col">Format</el-col><el-col :span="12" class="right-col">{{oneMultimedia.format}}</el-col>
              <el-col :span="12" class="left-col">BatchName</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch_id}}</el-col>
              <el-col :span="12" class="left-col">License</el-col><el-col :span="12" class="right-col">{{oneMultimedia.license}}</el-col>
              <el-col :span="12" class="left-col">Source</el-col><el-col :span="12" class="right-col">{{oneMultimedia.source}}</el-col>
              <el-col :span="12" class="left-col">OwnerInstitutionCode</el-col><el-col :span="12" class="right-col">{{oneMultimedia.owner_institution_code}}</el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Extended Metadata">
          <div class="MultimeidaInfo --el-box-shadow-light">
            <el-row>
              <el-col :span="12" class="left-col">Height</el-col><el-col :span="12" class="right-col">{{oneMultimedia.extended_metadata[0].height}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="left-col">Width</el-col><el-col :span="12" class="right-col">{{oneMultimedia.extended_metadata[0].width}}</el-col>
              <el-col :span="12" class="left-col">Size</el-col><el-col :span="12" class="right-col">{{oneMultimedia.extended_metadata[0].size}}</el-col>
              <el-col :span="12" class="left-col">Metadata License</el-col><el-col :span="12" class="right-col">{{oneMultimedia.extended_metadata[0].license}}</el-col>
              <el-col :span="12" class="left-col">Metadata Publisher</el-col><el-col :span="12" class="right-col">{{oneMultimedia.extended_metadata[0].publisher}}</el-col>
              <el-col :span="12" class="left-col">Metadata OwnerInstitutionCode</el-col><el-col :span="12" class="right-col">{{oneMultimedia.extended_metadata[0].owner_institution_code}}</el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Quality Metadata" v-if="oneMultimedia.quality_metadata.length>0">
          <div class="MultimeidaInfo --el-box-shadow-light">
            <span style="color:rgb(114 154 194);padding: 5px">* Image Quality Metadata for this image is inherited from the quality metadata of the root resource image</span>
            <el-row>
              <el-col :span="12" class="left-col">Organism Quantity</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].specimen_quantity}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="left-col">Non Specimen Objects</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].non_specimen_objects}}</el-col>
              <el-col :span="12" class="left-col">Contains Scalebar</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].contains_scalebar}}</el-col>
              <el-col :span="12" class="left-col">Contains Colorbar</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].contains_colorbar}}</el-col>
              <el-col :span="12" class="left-col">Contains Barcode</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].contains_barcode}}</el-col>
              <el-col :span="12" class="left-col">Brightness</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].brightness}}</el-col>
              <el-col :span="12" class="left-col">Color Issue</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].color_issue}}</el-col>
              <el-col :span="12" class="left-col">Parts Folded</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].parts_folded}}</el-col>
              <el-col :span="12" class="left-col">Parts Missing</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].parts_missing}}</el-col>
              <el-col :span="12" class="left-col">Parts Overlapping</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].parts_overlapping}}</el-col>
              <el-col :span="12" class="left-col">All Parts Visible</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].all_parts_visible}}</el-col>
              <el-col :span="12" class="left-col">Specimen Angle</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].specimen_angle}}</el-col>
              <el-col :span="12" class="left-col">Specimen View</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].specimen_view}}</el-col>
              <el-col :span="12" class="left-col">Specimen Curved</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].specimen_curved}}</el-col>
              <el-col :span="12" class="left-col">Uniform Background</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].uniform_background}}</el-col>
              <el-col :span="12" class="left-col">On Focus</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].on_focus}}</el-col>
              <el-col :span="12" class="left-col">Data Capture Method</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].data_capture_method}}</el-col>
              <el-col :span="12" class="left-col">License</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].license}}</el-col>
              <el-col :span="12" class="left-col">Publisher</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].publisher}}</el-col>
              <el-col :span="12" class="left-col">Owner Institution Code</el-col><el-col :span="12" class="right-col">{{oneMultimedia.quality_metadata[0].owner_institution_code}}</el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Batch">
          <div class="MultimeidaInfo --el-box-shadow-light">
            <el-row>
              <el-col :span="12" class="left-col">Batch Ark ID</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch.ark_id}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="left-col">Institution Code</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch.institution_code}}</el-col>
              <el-col :span="12" class="left-col">Pipeline</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch.pipeline}}</el-col>
              <el-col :span="12" class="left-col">Creator</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch.creator}}</el-col>
              <el-col :span="12" class="left-col">Creator Comment</el-col><el-col :span="12" class="right-col"><a target="_blank" v-if="oneMultimedia.batch.creator_comment !== ''" :href="oneMultimedia.batch.creator_comment"></a></el-col>
              <el-col :span="12" class="left-col">Contactor</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch.lab_code}}</el-col>
              <el-col :span="12" class="left-col">Project Name</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch.project_name}}</el-col>
              <el-col :span="12" class="left-col">URL</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch.url}}</el-col>
              <el-col :span="12" class="left-col">Dataset Name</el-col><el-col :span="12" class="right-col">{{oneMultimedia.batch.dataset_name}}</el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
<!--          default-expand-all = false-->
      <div class="MultimeidaTree">
        <el-tree
          :data = "treeData"
          node-key="ark_id"
          :expand-on-click-node="false"
        >
          <template #default="{ node, data }">
            <div class="custom-tree-node" :id=node.label>
              <span>Batch Name: {{ data.batch_id }}</span>
              <div style="width: 10px;display: inline-block;"> </div>
              <span>Ark ID: {{ data.ark_id }}</span>

              <div>
                <img style="width:30%" :src=data.path>
              </div>

            </div>
          </template>
        </el-tree>
      </div>

    </div>
  </el-dialog>

</template>

<script>

import {defineComponent,ref, onMounted} from 'vue';
import {getMultimediaByName,getMultimediaByArkID} from "@/utils/api";
import {Search,CircleCloseFilled,Download} from '@element-plus/icons-vue'
import {ElLoading} from 'element-plus'
export default defineComponent({
  setup(){
    const arkID = ref('')
    const genusName = ref('')
    const familyName = ref('')
    const minHeight = ref('')
    const maxHeight = ref('')
    const dataset = ref('GLIN')
    const isDownloadActive = ref('false')
    const multimediaList = ref([])
    const visible = ref(false)
    const oneMultimedia = ref()
    const datasetLists = [
      {
        value: 'GLIN',
        label: 'GLIN',
      },
      {
        value:'iDigBio',
        label:'iDigBio'
      },
      {
        value:'GBIF',
        label:'GBIF'
      },
      {
        value:'Morphbank',
        label:'Morphbank'
      },
      {
        value:'bounding box',
        label:'bounding box'
      },
      {
        value:'segmentation',
        label:'segmentation'
      },
      {
        value:'landmark',
        label:'landmark'
      },
    ]

    const treeData = ref([])
    const getName = () =>{
      const loading  = ElLoading.service(
          {
          }
      )
      getMultimediaByName({"genus":genusName.value,"family":familyName.value,"dataset":dataset.value,"zipfile":false},"json").then(res => {
        multimediaList.value = res.data
        loading.close()
      }).catch(err => {
        console.log(err)
        loading.close()
      })
    }
    const getArkID = (ev) =>{
      console.log(ev)
      getMultimediaByArkID(arkID.value).then(res => {
        showDialog(res.data)
      }).catch(err => console.log(err))
    }
    const downloadZipfile =() =>{
      const loading  = ElLoading.service(
          {
            lock:true,
            text:'Data Archiving...It may take a few minutes...',
            background:'rgba(0,0,0,0,0.7)'
          }
      )
      getMultimediaByName({"genus":genusName.value,"family":familyName.value,"dataset":dataset.value,"zipfile":true},"arraybuffer").then(res => {
        loading.close()
        let filename = ""
        if(res.headers["content-disposition"] !== undefined){
          filename = res.headers["content-disposition"].split(';')[1].split('filename=')[1];
          filename = filename.replace(new RegExp("\"","g"),"")

        }
        let blob = new Blob([res.data],{type:'application/zip'})
        let url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        if(filename!=="")
          link.download = filename
        link.click()
        URL.revokeObjectURL(url)
      }).catch(err => {
        console.log(err)
        loading.close()
      })
    }
    const showDialog = (item) =>{
      console.log(item)
      oneMultimedia.value=item

      let tempParent = item
      while(tempParent["parent"] !== null ){
          tempParent = tempParent["parent"]
        }
      let tempParentList =[]
      tempParentList.push(tempParent)
      treeData.value = tempParentList
      oneMultimedia.value.quality_metadata= tempParent["quality_metadata"]
      visible.value=true
    }
    const getList = () => {

      // const parameters = this.params
      // getIQ().then(res => console.log(res)).catch(err => console.log(err))
      // // axios
      // //     .get('http://127.0.0.1:8000/iq')
      // //     .then(response => (this.info = response))
      // //     .catch(function (error) { //
      // //       console.log(error);
      // //     });
    }
    onMounted(()=>{
      getList()
    })
    return {
      Search,
      arkID,
      getArkID,
      genusName,
      familyName,
      minHeight,
      maxHeight,
      dataset,
      datasetLists,
      getName,
      multimediaList,
      visible,
      CircleCloseFilled,
      showDialog,
      oneMultimedia,
      Download,
      isDownloadActive,
      downloadZipfile,
      treeData
    }
  },
  name: "SearchEntry",
  components:{CircleCloseFilled,Download}
})
// export default {
//
//   name: "SearchEntry",
//   data(){
//     return{
//       params:{
//         format:"jpg",
//         institution:"INHS"
//       }
//     }
//
//   },
//   methods:{
//
//   }
//
// }

</script>

<style lang="scss" scoped>
:deep(.MultimeidaTree){
  .el-tree-node__content{
    height: 100%
  }
}
.container .genus-input{
display: block;
}
.text-gray-600 {
  --un-text-opacity: 1;
  color: rgba(75,85,99,var(--un-text-opacity));
}
.items-center {
  align-items: center;
}
.w-35 {
  width: 5.00rem;
}
.inline-flex {
  display: inline-flex;
}

.ml-3 {
  margin-left: 0.75rem;
}
.w-50 {
  width: 12.5rem;
}
.m-2 {
  margin: 0.5rem;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  padding: 0;
  min-height: auto;
}

.image {
  width: 100%;
  display: block;
}

.my-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.left-col{
  padding: 12px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
  font-weight: 600;
}
.right-col{
  padding: 12px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;

}
.el-tree-node__content{
  height:100%
}
</style>